import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthGuardService } from '@xpo/security';
import { Observable } from 'rxjs/Observable';
import { retry } from 'rxjs/operators/retry';
import { AuthorizationService } from './authorization.service';

@Injectable()
export class AuthorizationGuard implements CanActivate {

  constructor(
    private authenticationGuard: AuthGuardService,
    private authorizationService: AuthorizationService,
    private router: Router,
  ) { }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    if (this.authenticationGuard.canActivate(route, state)) {
      return this.authorizationService.hasAccess(route.data.permissions).map((value) => {
        if (value) {
          return true;
        } else {
          this.router.navigate(['/']);
        }
      });
    }

    return false;
  }
}



// WEBPACK FOOTER //
// ./src/core/services/authorization-guard.service.ts